export const StandardDecks = [{
    "id": "standard-v1",
    "title": "Standard Deck",
    "category": "Caregiving",
    "description": "Core caregiving conversation cards in English, Korean, Spanish, and Simplified Chinese.",
    "languages": [
        "English",
        "Korean",
        "Spanish",
        "Simplified Chinese"
    ],
    coverImageUrl: "box.png",
    "cards": [
        {
            "questionNumber": 1,
            "category": "Opening",
            "prompts": {
                "en": "What's a childhood memory that still brings you joy?",
                "ko": "아직도 당신에게 기쁨을 주는 어린 시절의 추억은 무엇인가요?",
                "es": "¿Cuál es un recuerdo de su infancia que todavía le trae alegría?",
                "zh": "有什么童年记忆至今仍能带给您快乐？"
            }
        },
        {
            "questionNumber": 2,
            "category": "Opening",
            "prompts": {
                "en": "Is there someone in your life who was good at listening to you? What did they do that made you feel heard?",
                "ko": "당신의 이야기를 잘 들어주었던 사람이 있나요? 그들이 당신의 이야기를 경청하고 있다고 느끼게 한 것은 무엇인가요?",
                "es": "¿Hay alguien en su vida que haya sido bueno escuchándole? ¿Qué hicieron para que se sintiera escuchado?",
                "zh": "在您的生活中，有没有人善于倾听您心声？他们做了什么让您感觉被倾听了？"
            },
            "trial": true,
        },
        {
            "questionNumber": 3,
            "category": "Opening",
            "prompts": {
                "en": "When have you seen our family come together during challenging times?",
                "ko": "어려운 시기에 우리 가족이 함께 뭉쳤던 때는 언제인가요?",
                "es": "¿Cuándo ha visto a nuestra familia unirse durante tiempos difíciles?",
                "zh": "您何时看到我们一家人在困难时刻团结一致？"
            },
            "trial": true,

        },
        {
            "questionNumber": 4,
            "category": "Opening",
            "prompts": {
                "en": "What's a conversation you're glad we had as a family, even though it might have been difficult?",
                "ko": "비록 어려웠을지라도, 가족으로서 나눠서 다행이라고 생각하는 대화는 무엇인가요?",
                "es": "¿Cuál es una conversación que le alegra que hayamos tenido como familia, aunque haya sido difícil?",
                "zh": "我们一家人有什么对话虽然可能很困难，但您很庆幸我们进行了？"
            }
        },
        {
            "questionNumber": 5,
            "category": "Opening",
            "prompts": {
                "en": "What would make you feel like you're thriving as you grow older in the coming years?",
                "ko": "앞으로 나이가 들면서 당신이 성장하고 있다고 느끼게 할 것은 무엇인가요?",
                "es": "¿Qué le haría sentir que está prosperando a medida que envejece en los próximos años?",
                "zh": "在未来几年随着年龄增长，什么会让您感到自己活得很充实？"
            }
        },
        {
            "questionNumber": 6,
            "category": "Health & Independence",
            "prompts": {
                "en": "What daily activities bring you the most happiness and sense of independence?",
                "ko": "어떤 일상 활동이 당신에게 가장 큰 행복감과 독립감을 주나요?",
                "es": "¿Qué actividades diarias le traen más felicidad y sensación de independencia?",
                "zh": "哪些日常活动给您带来最多的幸福感和独立感？"
            }
        },
        {
            "questionNumber": 7,
            "category": "Health & Independence",
            "prompts": {
                "en": "Are there medical treatments or interventions you would refuse, even if recommended by doctors?",
                "ko": "의사가 권장하더라도 거부할 의료 치료나 중재가 있나요?",
                "es": "¿Existen tratamientos o intervenciones médicas que rechazaría, incluso si lo recomendaran los médicos?",
                "zh": "即使是医生推荐的医疗治疗或干预，有哪些您会拒绝的？"
            },
            "trial": true,

        },
        {
            "questionNumber": 8,
            "category": "Health & Independence",
            "prompts": {
                "en": "What values would be most important for anyone to understand if making health decisions on your behalf?",
                "ko": "다른 사람이 당신을 대신하여 건강 결정을 내릴 경우, 이해해야 할 가장 중요한 가치는 무엇인가요?",
                "es": "¿Qué valores serían más importantes que alguien comprendiera si tomara decisiones de salud en su nombre?",
                "zh": "如果有人要代表您做出健康决定，他们最需要了解您的哪些价值观？"
            }
        },
        {
            "questionNumber": 9,
            "category": "Health & Independence",
            "prompts": {
                "en": "If memory issues developed, what would you want us to prioritize in your daily care?",
                "ko": "기억력 문제가 생긴다면, 일상 케어에서 무엇을 우선시하기를 원하시나요?",
                "es": "Si desarrollara problemas de memoria, ¿qué le gustaría que priorizáramos en su cuidado diario?",
                "zh": "如果出现记忆问题，您希望我们在日常护理中优先考虑什么？"
            }
        },
        {
            "questionNumber": 10,
            "category": "Health & Independence",
            "prompts": {
                "en": "What subtle changes in your habits or mood would be meaningful signals that you might need additional support?",
                "ko": "당신의 습관이나 기분에 있어, 어떠한 미묘한 변화가,  추가 지원이 필요하다는 의미 있는 신호가 될까요?",
                "es": "¿Qué cambios sutiles en sus hábitos o estado de ánimo serían señales significativas de que podría necesitar apoyo adicional?",
                "zh": "您的习惯或情绪中哪些细微变化可能是您需要额外协助的重要信号？"
            }
        },
        {
            "questionNumber": 11,
            "category": "Health & Independence",
            "prompts": {
                "en": "What brings you the most comfort when you're not feeling well?",
                "ko": "건강이 좋지 않을 때 무엇이 가장 큰 위안이 되나요?",
                "es": "¿Qué le brinda más consuelo cuando no se siente bien?",
                "zh": "当您感觉不舒服时，什么能给您带来最大的舒适？"
            }
        },
        {
            "questionNumber": 12,
            "category": "Health & Independence",
            "prompts": {
                "en": "If driving became difficult for you, what alternative ways of maintaining your independence would be most important?",
                "ko": "운전이 어려워진다면, 독립성을 유지하기 위한 어떤 대안이 가장 중요할까요?",
                "es": "Si conducir le resultara difícil, ¿qué formas alternativas de mantener su independencia serían las más importantes?",
                "zh": "如果开车对您变得困难，哪些能让您保持独立的替代方式对您最重要？"
            }
        },
        {
            "questionNumber": 13,
            "category": "Health & Independence",
            "prompts": {
                "en": "If you needed in-home care, what qualities in a caregiver would be most important to you?",
                "ko": "재택 간병이 필요하다면, 간병인의 어떤 자질이 가장 중요한가요?",
                "es": "Si necesitara cuidado en casa, ¿qué cualidades en un cuidador serían más importantes para usted?",
                "zh": "如果您需要居家护理，护理人员的哪些品质对您最重要？"
            }
        },
        {
            "questionNumber": 14,
            "category": "Health & Independence",
            "prompts": {
                "en": "What's still on your bucket list that we might help you experience?",
                "ko": "우리가 당신이 경험하도록 도울 수 있는 버킷 리스트에 아직 남아있는 것은 무엇인가요?",
                "es": "¿Qué queda en su lista de deseos que podríamos ayudarle a experimentar?",
                "zh": "您的愿望清单上还有什么我们可以帮助您体验的事情？"
            }
        },
        {
            "questionNumber": 15,
            "category": "Health & Independence",
            "prompts": {
                "en": "Have you heard of advance directives or POLST forms? They're documents that let you spell out your medical care wishes if you can't communicate. Should we look into completing these together?",
                "ko": "사전 의료 지시서나 POLST 양식에 대해 들어보셨나요? 함께 작성해 볼까요?",
                "es": "¿Ha oído hablar de las directivas anticipadas o los formularios POLST? ¿Deberíamos considerar completarlos juntos?",
                "zh": "您听说过预立医疗指示或POLST表格吗？这些文件记录了您在无法表达时的医疗照护愿望。我们能一起完成这些吗？"
            }
        },
        {
            "questionNumber": 16,
            "category": "Health & Independence",
            "prompts": {
                "en": "Tell me about places where you've felt most at home. If we ever needed to consider different living arrangements, what would help you feel comfortable and settled?",
                "ko": "가장 편안함을 느꼈던 장소에 대해 말씀해 주세요. 다른 주거 형태를 고려해야 한다면, 무엇이 당신을 편안하게 할까요?",
                "es": "Cuénteme sobre los lugares donde se ha sentido más como en casa. Si alguna vez tuviéramos que considerar diferentes opciones de vivienda, ¿qué le ayudaría a sentirse cómodo y tranquilo?",
                "zh": "请告诉我您在哪些地方感觉最舒适自在。如果我们需要考虑不同的居住安排，什么会让您感到舒适？"
            }
        },
        {
            "questionNumber": 17,
            "category": "Health & Independence",
            "prompts": {
                "en": "What would help you feel dignity and independence in situations where you might need financial support from family members or assistance programs?",
                "ko": "가족 구성원이나 지원 프로그램으로부터 재정적 지원이 필요할 수 있는 상황에서, 존엄성과 독립성을 느끼는 데 무엇이 도움이 될까요?",
                "es": "¿Qué le ayudaría a sentir dignidad e independencia en situaciones en las que podría necesitar apoyo financiero de familiares o programas de asistencia?",
                "zh": "在可能需要来自家庭成员或援助计划的经济支持的情况下，什么会帮助您感到您可保持尊严和独立？"
            }
        },
        {
            "questionNumber": 18,
            "category": "Health & Independence",
            "prompts": {
                "en": "What aspects of your independence would be hardest to compromise on if caregiving became necessary, and how might we honor that?",
                "ko": "간병이 필요해질 경우, 당신의 독립성 중 어떤 측면을 타협하기가 가장 어려울까요? 그리고 우리는 그것을 어떻게 존중할 수 있을까요?",
                "es": "¿En qué aspectos de su independencia sería más difícil comprometerse si el cuidado fuera necesario, y cómo podríamos honrarlo?",
                "zh": "如果照护变得必要，您的独立性的哪些方面最难妥协？我们如何尊重这一点？"
            }
        },
        {
            "questionNumber": 19,
            "category": "Health & Independence",
            "prompts": {
                "en": "What aspects of your spirituality or personal beliefs would be important to honor in your care, especially during difficult times?",
                "ko": "특히 어려운 시기에, 당신의 돌봄에 있어 중요하게 존중되어야 할 영성이나 개인적 신념의 측면은 무엇인가요?",
                "es": "¿Qué aspectos de su espiritualidad o creencias personales sería importante honrar bajo su cuidado, especialmente en tiempos difíciles?",
                "zh": "特别是在困难时期，您的灵性或个人信仰中哪些方面在照顾您时非常重要？"
            }
        },
        {
            "questionNumber": 20,
            "category": "Health & Independence",
            "prompts": {
                "en": "How would you want us to balance your safety with your independence if concerns arise?",
                "ko": "우려가 생긴다면, 당신을 안전하게 지키는 것과 당신의 독립성을 존중하는 것 사이의 균형을 어떻게 맞추기를 원하시나요?",
                "es": "¿Cómo le gustaría que equilibráramos su seguridad con su independencia si surgen preocupaciones?",
                "zh": "如果出现担忧，您希望我们如何平衡您的安全和独立性？"
            }
        },
        {
            "questionNumber": 21,
            "category": "Planning & Legacy",
            "prompts": {
                "en": "Do you have a will? If not, how can we support you in making one?",
                "ko": "유언장이 있으신가요? 없다면, 작성하는 데 어떻게 도와드릴 수 있을까요?",
                "es": "¿Tiene un testamento? Si no, ¿cómo podemos ayudarle a crear uno?",
                "zh": "您有遗嘱吗？如果没有，我们如何协助您制定一份？"
            }
        },
        {
            "questionNumber": 22,
            "category": "Planning & Legacy",
            "prompts": {
                "en": "Where can we find your important health and legal documents if ever needed?",
                "ko": "필요할 경우 중요한 건강 및 법적 문서는 어디서 찾을 수 있나요?",
                "es": "¿Dónde podemos encontrar sus documentos legales y de salud importantes si alguna vez los necesitamos?",
                "zh": "如果需要，我们在哪里可以找到您重要的健康和法律文件？"
            }
        },
        {
            "questionNumber": 23,
            "category": "Planning & Legacy",
            "prompts": {
                "en": "If you couldn't manage your own money someday, what would help you still feel respected and independent?",
                "ko": "언젠가 자신의 돈을 관리할 수 없게 된다면, 무엇이 여전히 존중받고 독립적이라고 느끼는 데 도움이 될까요?",
                "es": "Si algún día no pudiera administrar su propio dinero, ¿qué le ayudaría a seguir sintiéndose respetado e independiente?",
                "zh": "如果有一天您无法管理自己的金钱财务，什么会让您仍然感到尊重和独立？"
            }
        },
        {
            "questionNumber": 24,
            "category": "Planning & Legacy",
            "prompts": {
                "en": "Which online accounts, photos, or digital memories would you want preserved if you couldn't manage them yourself?",
                "ko": "스스로 관리할 수 없게 된다면, 어떤 온라인 계정, 사진 또는 디지털 기억을 보존하고 싶으신가요?",
                "es": "¿Qué cuentas en línea, fotografías o recuerdos digitales le gustaría conservar si no pudiera administrarlos usted mismo?",
                "zh": "如果您无法自己管理，您希望保留哪些在线账户、照片或电脑的记忆？"
            }
        },
        {
            "questionNumber": 25,
            "category": "Planning & Legacy",
            "prompts": {
                "en": "What financial or logistical aspects of caregiving worry you most?",
                "ko": "간병의 재정적 또는 물류적 측면 중 가장 걱정되는 것은 무엇인가요?",
                "es": "¿Qué aspectos financieros o logísticos del cuidado le preocupan más?",
                "zh": "照护过程中，哪些财务或后勤方面是您最担心的？"
            }
        },
        {
            "questionNumber": 26,
            "category": "Planning & Legacy",
            "prompts": {
                "en": "What kind of gathering would feel most like 'you' when it comes time to celebrate your life? What touches would make you smile knowing they were included?",
                "ko": "당신의 삶을 기념할 때가 오면, 어떤 모임이 가장 '당신'다울까요? 어떤 요소가 포함되어 있다면 미소 짓게 될까요?",
                "es": "¿Qué tipo de reunión se sentiría más como \"usted\" cuando llegue el momento de celebrar su vida? ¿Qué detalles le harían sonreír sabiendo que fueron incluidos?",
                "zh": "当庆祝您的人生时，什么样的聚会最能代表您的个性？哪些细节会让您微笑，因为知道它们被特别考虑到？"
            }
        },
        {
            "questionNumber": 27,
            "category": "Planning & Legacy",
            "prompts": {
                "en": "Are there special places that have held meaning in your journey that might also be meaningful for your final resting place?",
                "ko": "당신의 여정에서 의미를 가졌던, 최종 안식처로도 의미가 있을 수 있는 특별한 장소가 있나요?",
                "es": "¿Hay lugares especiales que han tenido significado en su viaje que también podrían ser significativos para su lugar de descanso final?",
                "zh": "在您的人生旅程中，有没有对您有意义的特殊地方，也可能成为您最终安息地的有意义的地方？"
            }
        },
        {
            "questionNumber": 28,
            "category": "Planning & Legacy",
            "prompts": {
                "en": "Are there specific end-of-life wishes you haven't shared that would be important for us to know?",
                "ko": "우리가 알아야 할 중요한, 아직 공유하지 않은 특정한 생애 말기 소원이 있나요?",
                "es": "¿Hay deseos específicos para el final de la vida que no haya compartido y que sería importante que conociéramos?",
                "zh": "您有没有我们该知道的但还没告诉我们的临终愿望？"
            }
        },
        {
            "questionNumber": 29,
            "category": "Planning & Legacy",
            "prompts": {
                "en": "Where do you see yourself living in the next 5-10 years, and how might that affect our family's caregiving abilities?",
                "ko": "앞으로 5-10년 동안 어디서 살 것으로 생각하시나요? 그리고 그것이 우리 가족의 간병 능력에 어떤 영향을 미칠까요?",
                "es": "¿Dónde se ve viviendo en los próximos 5 a 10 años y cómo podría afectar eso las capacidades de cuidado de nuestra familia?",
                "zh": "您认为自己在未来5-10年会住在哪里？以及这可能會如何影响我们家庭的照护能力？"
            }
        },
        {
            "questionNumber": 30,
            "category": "Planning & Legacy",
            "prompts": {
                "en": "What's a story about yourself that you don't think I've ever heard?",
                "ko": "내가 들어본 적 없다고 생각하는 당신에 관한 이야기가 있나요?",
                "es": "¿Cuál es una historia sobre usted que cree que nunca he escuchado?",
                "zh": "有什么关于您自己的故事，您认为我从未听过？"
            }
        },
        {
            "questionNumber": 31,
            "category": "Planning & Legacy",
            "prompts": {
                "en": "What dreams or hopes for your life are you worried might be affected by caregiving responsibilities?",
                "ko": "간병 책임으로 인하여 영향을 받을까 걱정되는 당신 자신의 삶에 대한 꿈이나 희망은 무엇인가요?",
                "es": "¿Qué sueños o esperanzas para su vida le preocupan que puedan verse afectados por las responsabilidades de cuidado?",
                "zh": "您担心自己的哪些梦想或期望可能会受到照护责任的影响？"
            },
            "trial": true,

        },
        {
            "questionNumber": 32,
            "category": "Planning & Legacy",
            "prompts": {
                "en": "When you consider your resources for the years ahead, where do you feel most secure, and where might you welcome additional support or guidance?",
                "ko": "앞으로의 자원을 고려할 때, 어디서 가장 안정감을 느끼고, 어디서 추가 지원이나 도움을 받기 원하시요?",
                "es": "Cuando considera sus recursos para los años venideros, ¿dónde se siente más seguro y dónde podría recibir apoyo u orientación adicional?",
                "zh": "考虑到未来几年的资源，您在哪方面感到最安心，在哪方面您可能欢迎额外协助或引导？ "
            }
        },
        {
            "questionNumber": 33,
            "category": "Planning & Legacy",
            "prompts": {
                "en": "Beyond your will, have you thought about how you might want to distribute meaningful items or family heirlooms?",
                "ko": "유언장 외에도, 의미 있는 물건이나 가족 유산을 어떻게 분배하고 싶은지 생각해 보셨나요?",
                "es": "Más allá de su testamento, ¿ha pensado en cómo desea distribuir artículos significativos o reliquias familiares?",
                "zh": "除了遗嘱，您是否考虑过如何分配有意义的物品或家族传家宝？"
            }
        },
        {
            "questionNumber": 34,
            "category": "Planning & Legacy",
            "prompts": {
                "en": "What lifestyle factors or values are your most important considerations during retirement?",
                "ko": "은퇴 동안 가장 중요한 생활 방식 요소나 가치는 무엇인가요?",
                "es": "¿Qué factores o valores de estilo de vida son sus consideraciones más importantes durante la jubilación?",
                "zh": "在退休期间，您最重视哪些生活方式因素或价值观?"
            }
        },
        {
            "questionNumber": 35,
            "category": "Planning & Legacy",
            "prompts": {
                "en": "How would you want us to approach conversations about pooling family resources or sharing expenses if care needs arise?",
                "ko": "간병 필요가 생긴다면, 가족 자원을 모으거나 비용을 분담하는 것에 대한 대화를 어떻게 접근하길 원하시나요?",
                "es": "¿Cómo le gustaría que abordáramos las conversaciones sobre cómo combinar recursos familiares o compartir gastos si surgen necesidades de atención?",
                "zh": "如果出现照护需求，您希望我们如何讨论共享家庭资源或分担费用这话题？"
            }
        },
        {
            "questionNumber": 36,
            "category": "Relationship & Communication",
            "prompts": {
                "en": "What important topics seem to be the hardest for our family to discuss openly?",
                "ko": "우리 가족이 공개적으로 논의하기 가장 어려운 중요한 주제는 무엇인가요?",
                "es": "¿Qué temas importantes parecen ser los más difíciles de discutir abiertamente para nuestra familia?",
                "zh": "我们家庭之中，有哪些重要的话题比较难坦诚地讨论？\n\n"
            }
        },
        {
            "questionNumber": 37,
            "category": "Relationship & Communication",
            "prompts": {
                "en": "When you're feeling vulnerable, what small gesture makes you feel heard and cared for?",
                "ko": "취약함을 느낄 때, 어떤 작은 행동이 당신이 이해받고 보살핌 받는다고 느끼게 하나요?",
                "es": "Cuando se siente vulnerable, ¿qué pequeño gesto le hace sentir escuchado y atendido?",
                "zh": "当您感到脆弱时，什么小举动会让您感到被倾听和关心？"
            }
        },
        {
            "questionNumber": 38,
            "category": "Relationship & Communication",
            "prompts": {
                "en": "What's your greatest fear about how our relationship might change if one of us needed to care for the other?",
                "ko": "우리 중 한 명이 다른 사람을 돌봐야 한다면 우리 관계가 어떻게 변할지에 대한 가장 큰 두려움은 무엇인가요?",
                "es": "¿Cuál es su mayor temor sobre cómo podría cambiar nuestra relación si uno de nosotros necesitara cuidar al otro?",
                "zh": "如果将来有一方需要照顾对方，您最担心我们的关系会因此发生什么样的变化？"
            },
            "trial": true,

        },
        {
            "questionNumber": 39,
            "category": "Relationship & Communication",
            "prompts": {
                "en": "How can we divide caregiving responsibilities in ways that respects each person's strengths and life situations?",
                "ko": "각 사람의 강점과 삶의 상황을 존중하면서 간병 책임을 어떻게 나눌 수 있을까요?",
                "es": "¿Cómo podemos dividir las responsabilidades de cuidado de manera que se respeten las fortalezas y situaciones de la vida de cada persona?",
                "zh": "我们如何分配照护责任，以尊重每个人的优点和生活状况？ "
            }
        },
        {
            "questionNumber": 40,
            "category": "Relationship & Communication",
            "prompts": {
                "en": "How would taking on caregiving duties impact your work, family, or other commitments?",
                "ko": "간병 의무를 맡는 것이 당신의 직장, 가족 또는 다른 의무에 어떤 영향을 미칠까요?",
                "es": "¿Cómo afectaría el asumir tareas de cuidado a su trabajo, familia u otros compromisos?",
                "zh": "承担照护职责会如何影响您的工作、家庭或其他承诺？"
            }
        },
        {
            "questionNumber": 41,
            "category": "Relationship & Communication",
            "prompts": {
                "en": "What's the funniest misunderstanding we've had as a family?",
                "ko": "우리 가족으로서 가장 재미있게 오해했던 일은 무엇인가요?",
                "es": "¿Cuál es el malentendido más divertido que hemos tenido como familia?",
                "zh": "我们一家人发生过最搞笑的误解是什么？"
            }
        },
        {
            "questionNumber": 42,
            "category": "Relationship & Communication",
            "prompts": {
                "en": "What's one thing you wish others understood about your approach to difficult conversations or decisions?",
                "ko": "어려운 대화나 결정에 대한 당신의 접근 방식에 대해 다른 사람들이 이해했으면 하는 한 가지는 무엇인가요?",
                "es": "¿Qué es lo que le gustaría que los demás entendieran acerca de su manera de abordar conversaciones o decisiones difíciles?",
                "zh": "在面对困难的话题或决定时，您最希望别人能理解您那一点？"
            }
        },
        {
            "questionNumber": 43,
            "category": "Relationship & Communication",
            "prompts": {
                "en": "What would help our family communicate about caregiving responsibilities as they arise?",
                "ko": "간병을 해야하는 책임이 생길 때, 우리 가족이 어떻게 소통하면 좋을까요?",
                "es": "¿Qué ayudaría a nuestra familia a comunicarse sobre las responsabilidades de cuidado a medida que surjan?",
                "zh": "当照护责任出现时，什么样的方式能帮助我们家庭更好地沟通？"
            }
        },
        {
            "questionNumber": 44,
            "category": "Relationship & Communication",
            "prompts": {
                "en": "What unexpected strength did you notice about yourself when caring for someone you love in the past?",
                "ko": "과거에 사랑하는 사람을 돌볼 때 자신에게서 발견한 예상치 못한 강점은 무엇인가요?",
                "es": "¿Qué fortaleza inesperada notó en sí mismo cuando cuidó a alguien que amaba en el pasado?",
                "zh": "在过去照顾您所爱的人时，您注意到自己有什么意想不到的优点？"
            }
        },
        {
            "questionNumber": 45,
            "category": "Relationship & Communication",
            "prompts": {
                "en": "What information about our family member's health or preferences would help you feel more prepared?",
                "ko": "가족 구성원의 건강이나 선호에 관한 어떤 정보가 당신이 더 준비된 느낌을 갖는 데 도움이 될까요?",
                "es": "¿Qué información sobre la salud o preferencias de nuestro familiar le ayudaría a sentirse más preparado?",
                "zh": "关于我们家人们的健康或偏好，哪些信息会帮助您准备得更好？"
            }
        },
        {
            "questionNumber": 46,
            "category": "Relationship & Communication",
            "prompts": {
                "en": "If we could create an ideal support system for each other as we age, what would that look like to you?",
                "ko": "우리가 나이가 들면서 서로를 위한 이상적인 지원 시스템을 만들 수 있다면, 당신에게 그것은 어떤 모습일까요?",
                "es": "Si pudiéramos crear un sistema de apoyo ideal para los demás a medida que envejecemos, ¿qué le parecería?",
                "zh": "随着年龄的曾长，您认为我们为彼此建立的理想支持系统会是什么样子？ "
            }
        },
        {
            "questionNumber": 47,
            "category": "Relationship & Communication",
            "prompts": {
                "en": "How should we signal when there's something one of us wants to say that's hard to bring up?",
                "ko": "가족중 누군가가 꺼내기 어려운 이야기가 있을 때, 어떻게 다가가면 좋을까요?",
                "es": "¿Cómo deberíamos señalar cuando hay algo que uno de nosotros quiere decir y que es difícil de mencionar?",
                "zh": "当我们中的一个人有难以开口的事情时，我们应该如何表示？"
            }
        },
        {
            "questionNumber": 48,
            "category": "Relationship & Communication",
            "prompts": {
                "en": "When have you felt most understood by someone in this family, and what did they do that made you feel truly seen?",
                "ko": "이 가족 중 누군가에 의해 가장 이해받았다고 느꼈던 때는 언제이며, 그들이 당신을 진정으로 이해한다고 느끼게 한 것은 무엇인가요?",
                "es": "¿Cuándo se ha sentido más comprendido por alguien de esta familia y qué hizo para que usted se sintiera realmente visto?",
                "zh": "在这个家庭中，您何时感到被某人深刻理解？他们做了什么让您感到真正被看见？"
            }
        },
        {
            "questionNumber": 49,
            "category": "Relationship & Communication",
            "prompts": {
                "en": "How would you want to tell us if you received concerning news from a doctor, and how would you want us to respond?",
                "ko": "의사로부터 걱정되는 소식을 받았다면 어떻게 우리에게 알리고 싶으며, 우리가 어떻게 반응하기를 원하시나요?",
                "es": "¿Cómo le gustaría informarnos si recibiera noticias preocupantes de un médico y cómo le gustaría que le respondiéramos?",
                "zh": "如果您从医生那里收到令人担忧的消息，您希望如何告诉我们，并希望我们如何回应？"
            }
        },
        {
            "questionNumber": 50,
            "category": "Relationship & Communication",
            "prompts": {
                "en": "What concerns do you have about potentially becoming a caregiver that you haven't expressed?",
                "ko": "언젠가는 간병을 하게 될거라는 것에 대해 표현하지 않은 걱정거리가 있나요?",
                "es": "¿Qué inquietudes tiene sobre la posibilidad de convertirse en cuidador que no ha expresado?",
                "zh": "关于未来可能需要承担照护者角色，您有哪些未曾表达的担忧？ "
            }
        }
    ]
}]
